<template>
  <div class="application-scope">
    <div class="title">应用场景</div>
    <div class="box">
      <div class="left">
        <div class="subtitle">企业赋能</div>
        <div class="content">预置多种开源开放的AI/机器学习框架，灵活调度资源，降低 AI 应用开发的技术和成本门槛。</div>
      </div>
      <div  class="right">
        <div class="up">
          <div class="subtitle">教学实训</div>
          <div class="content">线上操作AI平台，支持远程教学，便捷的多用户管理，学生权限分配，老师教学更便利。</div>
        </div>
        <div class="down">
          <div class="subtitle">科学研究</div>
          <div class="content">超强算力GPU集群的支撑，先进的智能云平台技术，满足科研项目对算力的需求。</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
	export default {
		name: 'ApplicationScope',
		data() {
      return {}
    }
	}
</script>

<style>

	@media (min-width:992px) {
    .application-scope {
      background: #FFFFFF;
      padding: 120px 0;
    }

    .application-scope .title {
      margin: 0 auto;
      width: 120px;
      height: 34px;
      font-size: 30px;
      font-weight: 500;
      color: #3A3F4D;
      line-height: 34px;
    }

		.application-scope .box {
      width: 1400px;
      margin: 60px auto 0;
      display: flex;
      align-items: start;
      justify-content: space-between;
		}

		.application-scope .box .left {
			height: 364px;
			width: 687px;
      background-image: url("../assets/images/enterprise.png");
		}
    .application-scope .box .left .subtitle {
      width: 104px;
      height: 26px;
      font-size: 26px;
      font-weight: 500;
      color: #333333;
      line-height: 26px;
      margin: 130px 64px 0;
      text-align: start;
    }

    .application-scope .box .left .content {
      width: 353px;
      height: 52px;
      font-size: 16px;
      font-weight: 400;
      color: #333333;
      line-height: 26px;
      margin: 26px 64px 0;
      text-align: start;
    }

    .application-scope .box .right .subtitle {
      width: 104px;
      height: 26px;
      font-size: 26px;
      font-weight: 500;
      color: #333333;
      line-height: 26px;
      margin: 32px 32px 0;
      display: table-caption;
    }

    .application-scope .box .right .content {
      width: 353px;
      height: 52px;
      font-size: 16px;
      font-weight: 400;
      color: #333333;
      line-height: 26px;
      margin: 26px 32px 0;
      text-align: start;
      opacity: 0.7;
    }
    .application-scope .box .right .up {
      background-image: url("../assets/images/education.png");
      width: 687px;
      height: 168px;
    }
    .application-scope .box .right .down {
      background-image: url("../assets/images/science.png");
      width: 687px;
      height: 168px;
      margin-top: 28px;
    }
	}

	@media (max-width:992px) {
		.application-scope .title {
			padding-top: 10px;
			margin-bottom: 15px;
		}

		.application-scope .title h2 {
			font-size: 18px;
			line-height: 60px;
		}

		.application-scope .title .vertical::before {
			content: '';
			display: block;
			position: absolute;
			top: 3px;
			left: -12px;
			width: 4px;
			height: 18px;
			background-color: #25A5FF;
		}

		.application-scope .box {
			display: flex;
			flex-direction: column;
			justify-content: space-between;
			align-items: center;
			margin: 0 10px;
			padding: 0;
		}

		.application-scope .box .item {
			margin: 0;
			padding: 0;
		}

		.application-scope .box .item .up {
			height: 60px;
			padding: 3px 10px;
			margin-bottom: 3px;
			background-color: rgba(52, 156, 227, .1);
			align-items: center;
			border-radius: 4px;
		}

		.application-scope .box .item .up img {
			height: 50px;
		}

		.application-scope .box .item .up h4 {
			margin: 0 0 0 5px;
		}
		.application-scope .box .item p {
			margin: 0 5px;
		}
	}
</style>
<style></style>


// WEBPACK FOOTER //
// src/components/ApplicationScope.vue